import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  coverImages: [],
  error: null,
};

const coverImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_CARECELL_COVERIMAGE_REQUEST:
    case actionTypes.UPDATE_CARECELL_COVERIMAGE_REQUEST:
      case actionTypes.DELETE_CARECELL_COVERIMAGE_REQUEST:

      return { ...state, loading: true, error: null };

    case actionTypes.SAVE_CARECELL_COVERIMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        coverImages: [...state.coverImages, action.payload],
      };

    case actionTypes.UPDATE_CARECELL_COVERIMAGE_SUCCESS:
      // Update existing carecell cover image in array
      const exists = state.coverImages.some(
        (img) => img.carecellObjId === action.payload.carecellObjId
      );
      return {
        ...state,
        loading: false,
        coverImages: exists
          ? state.coverImages.map((img) =>
              img.carecellObjId === action.payload.carecellObjId
                ? action.payload
                : img
            )
          : [...state.coverImages, action.payload],
      };

case actionTypes.DELETE_CARECELL_COVERIMAGE_SUCCESS:
  return {
    ...state,
    loading: false,
    coverImages: state.coverImages.filter(
      (img) =>
        !(
          img.carecellObjId === action.payload.carecellObjId &&
          img.carecellCoverImageObjId === action.payload.carecellCoverImageObjId
        )
    ),
  };


    case actionTypes.SAVE_CARECELL_COVERIMAGE_FAILURE:
    case actionTypes.UPDATE_CARECELL_COVERIMAGE_FAILURE:
      case actionTypes.DELETE_CARECELL_COVERIMAGE_FAILURE:

      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default coverImageReducer;
